import React from 'react';

interface CheckIconProps {
  className?: string;
  /**
   * Visual variant. `filled` (default) is the Heroicons mini solid style
   * (20x20). `stroked` is the 24x24 outline variant used inside diagnostic
   * checklists.
   */
  variant?: 'filled' | 'stroked';
  strokeWidth?: number | string;
}

/**
 * Checkmark icon. Used for success states, completed items, etc.
 */
export function CheckIcon({
  className = 'h-4 w-4',
  variant = 'filled',
  strokeWidth = 2,
}: CheckIconProps): React.ReactElement {
  if (variant === 'stroked') {
    return (
      <svg
        className={className}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        aria-hidden="true"
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
      </svg>
    );
  }
  return (
    <svg className={className} fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
      <path
        fillRule="evenodd"
        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
        clipRule="evenodd"
      />
    </svg>
  );
}
